import React from "react";
import DropDownSelect from "./DropDown";
import WhiteDropDown from "./images/dropdownWhiteIcon.svg";
import WhiteDiamong from "./images/whiteDiamon.svg";

function CollectionHeader(props) {
  return (
    <div style={{ textAlign: "center" }}>
      <h1 style={{ color: "#fff", fontWeight: "400", fontSize: "1rem" }}>
        SELECTED COLLECTION
      </h1>
      <DropDownSelect
        menuItem={props.collectionList}
        selectedItem={props.currentCollection}
        selectedItemId={props.currentCollectionId}
        itemSelected={props.itemSelected}
        className="headerDropDown"
        rightSideIcon={WhiteDropDown}
        leftSideIcon={WhiteDiamong}
        makeLinks={true}
        affiliateUsername={props.affiliateUsername}
        collectionUrl={props.collectionUrl}
      />
      <div
        className="underline"
        style={{ marginTop: 0, marginBottom: "1rem" }}
      />
    </div>
  );
}
export default CollectionHeader;



// WEBPACK FOOTER //
// ./src/CollectionHeader.jsx